import React from 'react';
import { LucideIcon, ArrowRight } from 'lucide-react';

interface MobileServiceCardCarouselProps {
  icon: LucideIcon;
  title: string;
  description: string;
  onClick?: () => void;
}

const MobileServiceCardCarousel: React.FC<MobileServiceCardCarouselProps> = ({
  icon: Icon,
  title,
  description,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className="relative bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden h-72 transition-all duration-300 active:scale-95"
    >
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-50 via-white to-gray-50 opacity-60" />
      
      {/* Content */}
      <div className="relative h-full flex flex-col p-6">
        {/* Icon avec effet premium */}
        <div className="mb-4">
          <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center shadow-lg shadow-amber-500/30 transform rotate-3 transition-transform hover:rotate-0">
            <Icon className="w-8 h-8 text-white" />
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
          {title}
        </h3>

        {/* Description */}
        <p className="text-sm text-gray-600 leading-relaxed flex-1 line-clamp-4">
          {description}
        </p>

        {/* Footer CTA */}
        <div className="mt-4 pt-4 border-t border-gray-100">
          <button className="w-full flex items-center justify-center gap-2 py-2.5 bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-xl text-sm font-medium hover:shadow-lg transition-all">
            Découvrir
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Accent decoratif */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-amber-400/10 to-transparent rounded-bl-full" />
    </div>
  );
};

export default MobileServiceCardCarousel;
